import http from "../components/config/axiosConfig";

const connect = (token) => {
    return http.get('/connect', {
        params: {
            "token": token
        }
    })
};

const reconnect = (token) => {
    return http.get('/reconnect', {
        params: {
            "token": token
        }
    })
};

const token = {
    connect,
    reconnect
}

export default token